export class Address {
    Address1: string;
    City: string;
    State: string;
    Zip: string;
    DwellingType: string;
    YearBuilt: number;
    SquareFootage: number;
    Id: string;
    Country: string;
    Tenant: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";
}
